'use strict';

var Group_v1alpha1_schema = require('../schema/kinds/Group.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const groupEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(Group_v1alpha1_schema.default);

exports.groupEntityV1alpha1Validator = groupEntityV1alpha1Validator;
//# sourceMappingURL=GroupEntityV1alpha1.cjs.js.map
